export const SUMMARY_ENABLED_COOKIE_NAME = 'hn-search-summary-enabled';
export const SUMMARY_ENABLED_COOKIE_VALUE = '1';
export const SUMMARY_DISABLED_COOKIE_VALUE = '0';

export const SUMMARY_VISITED_COOKIE_NAME = 'hn-search-summary-visited';
export const SUMMARY_VISITED_COOKIE_VALUE = '1';

export const COOKIE_EXPIRY_DAYS = 365;
